import $ from 'jquery'
import 'bootstrap'
import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import saveAs from 'file-saver'

$(function () {
    var flag = false;
    // Toggle login
    $('#login-toggle-button').on('touchstart click', function () {
        if (!flag) {
            flag = true;
            setTimeout(function () { flag = false; }, 100);

            $('#loginForm').toggleClass('in-the-open');
            $('#quickSearch').removeClass('in-the-open');
            $('#language-choices').removeClass('in-the-open');
        }
        return false;
    });

    // Toggle logout
    $('#logout-toggle-button').on('touchstart click', function () {
        if (!flag) {
            flag = true;
            setTimeout(function () { flag = false; }, 100);
            $('.loginPrompt > .btn').toggleClass('in-the-open');
            $('#quickSearch').removeClass('in-the-open');
            $('#language-choices').removeClass('in-the-open');
        }
        return false;
    });

    // Toggle search
    flag = false;
    $('#toggle-search-bar').on('touchstart click', function () {

        if (!flag) {
            flag = true;
            setTimeout(function () { flag = false; }, 100);
            $('#quickSearch').toggleClass('in-the-open');
            $('#loginForm').removeClass('in-the-open');
            $('#language-choices').removeClass('in-the-open');
        }
        return false;
    });

    // Toggle language
    flag = false;
    $('#chosen-language').on('touchstart click', function () {
        if (!flag) {
            flag = true;
            setTimeout(function () { flag = false; }, 100);
            $('#language-choices').toggleClass('in-the-open');
            $('#loginForm,.loginPrompt > .btn').removeClass('in-the-open');
            $('#quickSearch').removeClass('in-the-open');
            
        }
        return false;
    });

    // Toggle images & Regulatory 
    $('.btn.toggle-images, .btn.toggle-regulatory').on('click', function () {
        let textShow = $(this).find('.open');
        let textHide = $(this).find('.closed');

        if ($(this).siblings('.show').length > 0) {
            textShow.removeClass('d-none');
            textHide.addClass('d-none');
        }
        else {
            textShow.addClass('d-none');
            textHide.removeClass('d-none');
        }
    });

    $('.product-image-container img').css({'width': $('.product-image-caption').innerWidth(), 'height': 'auto'});

    $('.product-thumbnails img').on('click', function (e) {
        e.preventDefault();
        let thumbnail = $(this);
        let thumbnailSrc = thumbnail.attr("src");
        let productImg = $(".product-image-container").find('.product-image img');
        let productImgSrc = productImg.attr("src");
        if (thumbnailSrc && productImgSrc) {
            if (productImg.alt)
                thumbnail.attr('alt', productImg.alt);

            thumbnail.attr('src', productImgSrc);
            thumbnail.parent().attr('href',productImgSrc);

            if (thumbnail.alt)
                productImg.attr('alt', thumbnail.alt);

            let productImageDownload = $(".product-image-caption").find('.product-image-download');
            productImageDownload.attr('href', thumbnailSrc);
            productImageDownload.attr('download', thumbnailSrc);
            productImg.attr('src', thumbnailSrc);
            productImg.parent().attr('href', thumbnailSrc);
        }
    });

    // Toggle variant dropdown
    $('.product-variant-list li').on('click', function () {
        let itemSelected = $(this);
        let displayedItem = $('.product-variant-selected');
        let buyBtn = $('#buyButton');
        displayedItem.html(itemSelected.children().clone().removeClass('open'));

        displayedItem.attr('data-selected-id',
          itemSelected.attr('data-variant-id'),
        );
        displayedItem.attr('data-selected-pcon-nbr',
          itemSelected.attr('data-pcon-nbr')
        )

        buyBtn.attr('data-article-number', itemSelected.attr('data-variant-id'))
        buyBtn.attr('key', itemSelected.attr('data-variant-id'))

        $('.product-variant-list').stop().slideUp();
    });

    $('.product-variant-selected').on('click', function () {
        $('.product-variant-list').stop().slideToggle();
        $(this).toggleClass('open');
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.product-variant-list, .product-variant-selected:not(.show)').length === 0) {
            $('.product-variant-list').stop().slideUp();
            $('.product-variant-selected').removeClass('open')
        }
    });

    // Download dropdown toggle it open/close
    $(".download-text").on("click", function(e) {
        $('.download-list').stop().slideToggle();
        $(".download-text").toggleClass('open');
    });

    // Download dropdown hide it when clicking anywere on page
    $(document).on('click', function (e) {
        if ($(e.target).closest('.download-list, .download-text:not(.show)').length === 0) {
            $('.download-list').stop().slideUp();
            $('.download-text').removeClass('open');
        }
    });

    // Download dropdown click on download zip
    $('.download-all').on('click', function (e) {
        e.stopPropagation();
        createZip();
    });

    function createZip() {
        const zip = new JSZip();
        const downloadList = $(".download-list");
        const list = downloadList[0].children;

        for (let i = 0; i < list.length; i++)
        {
            let ref;
            let name;
            let a = list[i].querySelector('a');
            let attr = a.attributes;

            for (let x = 0; x < attr.length; x++)
            {
                if (attr[x].name === "href")
                    ref = attr[x].value;

                if (attr[x].name === "data-file")
                    name = attr[x].value;
            }

            if (name && ref) {
                let url = window.location.origin+ref;
                zip.file(name, urlToPromise(url), {binary:true});

                if (i === list.length-2) {
                    zip.generateAsync({type:"blob"})
                        .then(function callback(blob) {
                            saveAs(blob, "downloads.zip");
                        });
                }
            }
        }
    }

    function urlToPromise(url) {
        return new Promise(function(resolve, reject) {
            JSZipUtils.getBinaryContent(url, function (err, data) {
                if(err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }

    // Toggle favorite 
    $('body').on('click', '#toggleFavorite', function () { 
        var storage = window.localStorage; 
        var productKey = $(this).data("key"); 
        var storageKey = 'fav_' + productKey; 
        if (!storage.getItem(storageKey)) { 
            var value = { 
                key: productKey, 
                name: document.querySelector(".product-detail__name").innerText, 
                variantName: document.querySelector(".product-variant-selected .variant-name").innerText, 
                variantId: document.querySelector(".product-variant-selected .variant-id").innerText, 
                image: document.querySelector(".product-detail__image--main").getAttribute("src"),
                url: window.location.href
            }; 
 
            storage.setItem(storageKey, JSON.stringify(value)); 

            $(".fav_"+productKey).each(function(index, obj){
                $(obj).addClass('fav-added');
            });
        } 
        else { 
            storage.removeItem(storageKey);
            $(".fav_"+productKey).each(function(index, obj){
                $(obj).removeClass('fav-added');
            });
        } 
    }); 
 
    // Render favorite list 
    function listFavorites() { 
        var template = $('#favorite-template').html(); 
        var container = $('#favorites'); 
        container.empty(); 
        for (var i = 0; i < window.localStorage.length; i++) { 
            var key = window.localStorage.key(i); 
            if (!key.startsWith('fav_')) continue; 
 
            var item = window.localStorage.getItem(key); 
            if (!item) continue; 
 
            var json = JSON.parse(item); 
 
            var itemTemplate = $(template).clone(); 
            itemTemplate.find('.fav-image').attr('src', json.image); 
            itemTemplate.find('.fav-name').text(json.name); 
            itemTemplate.find('.fav-variant').text(json.variantName + ' ' + json.variantId); 
            itemTemplate.find('.fav-link').attr('href', json.url);
            var removeButton = itemTemplate.find('.removeFavorite'); 
            removeButton.attr('data-key', json.key); 
 
            container.append(itemTemplate); 
        } 
 
        if (container.children().length === 0) { 
            container.append($("<strong>").text("No products saved in favourites")); 
        } 
    } 
 
    //Remove favorite from list 
    $(document).on('click', '.removeFavorite', function () { 
        var storage = window.localStorage; 
        var variant = $(this).data("key"); 
        var key = 'fav_' + variant; 
        storage.removeItem(key); 
        $("." + key).removeClass('fav-added'); 
        listFavorites(); 
    }); 

    // Show favorites
    $(".fav-mobile, .fav-desktop").on("click", function () { 
        listFavorites(); 
        $("#favorites").stop().fadeToggle(); 
    }); 
 
    // Hide favorites if we click outside of favorite list 
    $(document).on('mouseup', function (e) {  
        var btnFav = $('#showFavorites'); 
        var container = $("#favorites"); 

        if (!container.is(e.target) && container.has(e.target).length === 0 && !btnFav.is(e.target)) {
            container.stop().fadeOut(); 
        } 
    });

    // Ensure that we highlight existing favorites when page loads 
    for (var i = 0; i < window.localStorage.length; i++) { 
        var key = window.localStorage.key(i); 
        if (!key.startsWith('fav_')) continue;
        $('.' + key).addClass('fav-added'); 
    }

    if ($("#search-result").length ) {
        let pagination = $("#search-result").find(".pagination li a");
        for (let i = 0; i < pagination.length; i++) {
            if (pagination[i].innerHTML === "&lt;&lt;") {
                pagination[i].innerHTML = "&lt;"
            }
            if (pagination[i].innerHTML === "&gt;&gt;") {
                pagination[i].innerHTML = "&gt;"
            }
        }
    }
});
